<template>
    <div class="form-group" :class="model.size">
        <div>
            <label class="font-weight-bold">{{ model.label }}</label>
            <i class="far fa-edit float-right text-primary pointer" @click="showEditPrompt"></i>
        </div>
        <div aria-describedby="descriptionHelp">
            <toggle v-model="model.booleanDefaultValue" :disabled="true"></toggle>
        </div>
        <small id="descriptionHelp" class="form-text text-muted">{{ isEnVersion ? model.descriptionEn : model.description }}</small>

        <vs-prompt :title="$t('editor.common.editComponentProperties')"
                   :accept-text="$t('buttons.ok')"
                   :cancel-text="$t('buttons.cancel')"
                   :active.sync="activePrompt"
                   :is-valid="validationSuccess"
                   @cancel="cancelPrompt"
                   @close="cancelPrompt"
                   color="primary">
            <div>
                <div v-if="model.locked">
                    <h4 class="text-danger"><i class="fas fa-lock"></i> {{ $t('registers.dynamic.gridHeaders.locked') }}</h4>
                </div>

                <FieldTemplateSelector v-model="model"
                                       :isFormField="isFormField"
                                       :isAuxRegisterField="isAuxRegisterField"
                                       :isEventFieldCode="isEventFieldCode">
                </FieldTemplateSelector>

                <vs-input :label="$t('editor.common.name')" v-model="model.name" />
                <span class="text-danger" v-if="!validName">{{ $t('validation.requiredField') }}</span>

                <div class="row mt-2 mb-2 pl-3">
                    <vs-checkbox v-model="model.isTemplate">{{ $t('editor.common.saveAsTemplate') }}</vs-checkbox>
                </div>

                <vs-input :label="$t('editor.common.nameEN')" v-model="model.nameEn"></vs-input>

                <vs-input :label="$t('editor.common.label')" v-model="model.label" />
                <span class="text-danger" v-if="!validLabel">{{ $t('validation.requiredField') }}</span>
                <vs-input :label="$t('editor.common.labelEn')" v-model="model.labelEn"></vs-input>
                <span class="text-danger" v-if="!validLabelEN">{{ $t('validation.requiredField') }}</span>

                <vs-input :label="$t('editor.common.description')" v-model="model.description" />
                <vs-input :label="$t('editor.common.descriptionEn')" v-model="model.descriptionEn" />

                <size-dropdown v-model="model.size"></size-dropdown>

                <div class="mt-2">
                    <span class="vs-select--label">{{ $t('editor.common.defaultValue') }}</span>
                    <toggle v-model="model.booleanDefaultValue"></toggle>
                </div>
                <div class="float-left mt-2">
                    <vs-checkbox v-model="model.isRequired">{{ $t('validation.requiredField') }}</vs-checkbox>
                </div>
                <div class="float-left mt-2">
                    <vs-checkbox v-model="model.isReadOnly">{{ $t('validation.readOnlyField') }}</vs-checkbox>
                </div>

                <div class="clearfix"></div>
                <hr />
                <div class="float-left mt-2">
                    <vs-checkbox v-model="model.showInDescription">{{ $t('editor.common.showInDescription') }}</vs-checkbox>
                </div>

                <div class="clearfix"></div>
            </div>
        </vs-prompt>

    </div>
</template>

<script>
    import Toggle from '../toggle/Toggle';
    import { EditorComponentModel } from '../../models/models.js';
    import SizeDropdown from '../../components/editor/SizeDropdown';
    import FieldTemplateSelector from '../../components/editor/FieldTemplateSelector'
    import { Culture } from '../../models/enums';

    export default {
        props: {
            model: EditorComponentModel,
            isFormField: {
                type: Boolean,
                default: false
            },
            isAuxRegisterField: {
                type: Boolean,
                required: false
            },
            isEventFieldCode: {
                type: Boolean,
                required: false
            },
        },
        components: {
            Toggle,
            SizeDropdown,
            FieldTemplateSelector
        },
        data() {
            return {
                activePrompt: false,
                originalModel: new EditorComponentModel()
            }
        },
        methods: {
            showEditPrompt(event) {
                this.originalModel = new EditorComponentModel(this.model);
                this.activePrompt = true;
            },
            cancelPrompt() {
                this.changeModelToOriginalModel();
            },
            changeModelToOriginalModel() {
                this.model.name = this.originalModel.name;
                this.model.nameEn = this.originalModel.nameEn;
                this.model.label = this.originalModel.label;
                this.model.labelEn = this.originalModel.labelEn;
                this.model.size = this.originalModel.size;
                this.model.booleanDefaultValue = this.originalModel.booleanDefaultValue;
                this.model.isRequired = this.originalModel.isRequired;
                this.model.isReadOnly = this.originalModel.isReadOnly;
                this.model.showInDescription = this.originalModel.showInDescription;
            },
        },
        computed: {
            validName() {
                return this.model.name.length > 0;
            },
            validLabel() {
                return this.model.label.length > 0;
            },
            validLabelEN() {
                return this.model.labelEn.length > 0;
            },
            validationSuccess() {
                // this.mode.locked - Locked for edition
                return !this.model.locked && this.validName && this.validLabel && this.validLabelEN;
            },
            fieldTemplateSelected() {
                return !isNaN(this.fieldTemplateId) && this.fieldTemplateId > 0;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
        }
    }
</script>

<style scoped>
    .vs-input {
        width: 100%;
    }

    ::v-deep {
        .vs-dialog {
            min-width: 800px !important;
            height: auto;
        }
    }
</style>
